
export default {
  convertLocalDateToUTCDate: function (date) {
    date = date + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds()
    date = new Date(date)
    var convDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds())
    return convDate
  },

  conversionbyNag: function (date) {
    var doo = new Date(date)
    // var timezoneoffset = -120; // gmt+2, == -120 (minutes)
    // console.log("NEW COnversion: "+ new Date( doo.getTime() - doo.getTimezoneOffset() * -60000 ) )
    return new Date(doo.getTime() - doo.getTimezoneOffset() * -60000)
  },
  strToDate: function (strDate) {
    try {
      // -1 became javascript has months from 0-11
      return new Date(strDate.substring(0, 4), strDate.substring(5, 7) - 1, strDate.substring(8, 10), 12, 0, 0, 0)
    } catch (e) {
      console.log('Error in Date in conversion' + strDate)
    }
  },
  formatDateMoment: function (date) {
    try {
      return new Date(date.year(), date.month(), date.date(), 12, 0, 0, 0)
    } catch (e) {
      console.log('Error in Date in conversion formatDate' + date)
    }
  },
  formatDateJS: function (date) {
    try {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0, 0)
    } catch (e) {
      console.log('Error in Date in conversion formatDate' + date)
    }
  }
}
